module.exports = __webpack_public_path__ + "static/img/akum_100.55afbb8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akum_100.svg
// module id = ppzO
// module chunks = 1